import { getCookie } from './updateLocaleCookie';

// At 10% result guid needs 0x00 < value <= 0x19
const contentSquareRampUpPercent = 10;

const isRampedUp = (hexString, rampPercent) => {
  if (rampPercent === 0 || typeof hexString === 'undefined') return false;
  const dec = Number.parseInt(hexString.slice(-2), 16);
  const percentage = Math.round((dec / 255) * 100);

  return percentage <= rampPercent;
};

const contentSquareAllowedGUIDs = new Set([
  '1965adc767d9241b255456c3788ba9d8',
  '534e560da620c52e65bb4dc44b813db2',
  'a4c5fc99ee92027610441aadc9a9bc01',
  'a6c72549ddfef0c4372767ef73312a6c',
  'aaa584a44feaf8f72ead5cb6fd911ee8',
  'acfd6cce1686481ee9fedc7bd347ed4f',
  'b6c6c15f7b5ac5f91287a9490fea69a6',
  'ec9a55c451bb50b709e27808ca1e5dd5',
  'c35f37fb690057c2b7c86b9ac87567b7',
  '5f1fe47faa55315100b06512867adfe5',
]);

export const isContentSquareAllowedToLoad = () => {
  const publicGuid = getCookie('blueboxpublic');

  return contentSquareAllowedGUIDs.has(publicGuid)
    || isRampedUp(publicGuid, contentSquareRampUpPercent);
};
